const ContactBtnData = [
  {
    id: 0,
    h6Text: (
      <>
        We appreciate the generosity of our sponsors. Sponsoring our events can
        provide a range of benefits to your organization, including:
      </>
    ),
    liText1: (
      <>
        <b>Brand exposure:</b> Reach a wider audience and build brand
        recognition by increasing your brand’s visibility among the attendees.
      </>
    ),
    liText2: (
      <>
        <b>Networking opportunities:</b> Build relationships and expand your
        reach by networking with fellow industry professionals, potential
        customers, and partners.
      </>
    ),
    liText3: (
      <>
        <b>Lead generation:</b> Identify new business opportunities and increase
        your sales by generating leads as ACBC provides you with access to your
        targeted audience.
      </>
    ),
    liText4: (
      <>
        <b>Thought leadership:</b> Position your organization as a thought
        leader in the industry. By sharing your expertise and insights with the
        attendees, you can establish yourself as an authority in your field.
      </>
    ),
    liText5: (
      <>
        <b>Community involvement:</b> Improve your reputation and build trust,
        by demonstrating your organization’s commitment and social
        responsibility to the community.
      </>
    ),
    paragraphText: (
      <>
        If you are interested in becoming a sponsor. Please complete the form
        below. Our team will contact you to see what type of sponsorship is
        ideal for your company.
      </>
    ),
  },
];

export default ContactBtnData;
